//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import UserHeader from "./UserHeader";
import { Col, Row } from 'vant';
import BaseNoticeItem from "../../components/BaseNoticeItem";

export default {
  data() {
    return {
      baseNoticeList: []
    };
  },
  components: {
    UserHeader,
    BaseNoticeItem
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      menus: (state) => state.user.menus,
      responsibilityId: (state) => state.user.responsibilityId,
    }),
    respMenus: {
      get() {
        return this.initMenus()
      },
      set(val) {},
    },
  },
  created() {},
  activated: function () {},
  methods: {
    initMenus() {
      if(this.menus == null || this.menus[this.responsibilityId] == null) return []
      const menus = this.menus[this.responsibilityId].map((item) => {
        let toPath = "";
        let icon = "photo-o";
        /*switch (item.menuCode) {
          case "DACK":
            toPath = "/fileRecord";
            icon = 'records'
            break;
          case "JXCK":
            toPath = "/performance";
            icon = 'bar-chart-o'
            break;
          case "BJLB":
            toPath = "/QuoteList";
            icon = 'orders-o'
            break;
          case "XJBM":
            toPath = "/AuctionList";
            icon = 'newspaper-o'
            break;
          case "DDQR":
            toPath = "/orderComfirm";
            icon = 'certificate'
            break;
          case "DDCX":
            toPath = "/orderSearch";
            icon = 'search'
            break;
          case "SHTZ":
            toPath = "/noticeList";
            icon = 'bell'
            break;
          case "SHD":
            toPath = "/deliveryList";
            icon = 'logistics'
            break
          case "DBCK1":
            toPath = "/SupplierPendingList";
            icon = 'orders-o'
            break;
          case "DBCK2":
            toPath = "/InteriorPendingList";
            icon = 'orders-o'
            break;
          case "GRZX":
            toPath = "/mine";
            icon = 'orders-o'
            break;
          case "ZBBJ":
            toPath = "/biddingList";
            icon = 'cash-on-deliver'
            break;
        }*/
        item.toPath = !!!item.htmlUrl ? toPath : item.htmlUrl
        item.icon = !!!item.imageLink ? icon : item.imageLink
        return item;
      });
      return menus;
    },
    listNotice() {
      fetch.notice_listSummaryByPage({
        pageIndex: 1,
        pageRows: 10,
        userId: this.userInfo.userId,
        supplierId: this.userInfo.supplierId,
      }).then((res) => {
        this.baseNoticeList = res.data
      });
    },
    /**查看公告详情*/
    doShowNotice(notice) {
      this.$router.push({
        name: 'noticeDetailView',
        params: {noticeId: notice.noticeId},
        query: {}
      })
    },
    /**显示更多公告*/
    viewMoreBaseNotice(notice) {
      /*this.$router.push({
        name: 'testScan',
        params: {},
        query: {}
      })*/
      this.$router.push({
        name: 'baseNoticeList',
        params: {},
        query: {}
      })
    }
  },
  watch: {},
  mounted() {
    this.listNotice()
    this.initMenus()
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/home/Home.vue